import Highcharts from 'highcharts';
import HC_accessibility from 'highcharts/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';

import { calculateTime, formatTime } from '../../utils/helper';

HC_accessibility(Highcharts);

const RoadChart = ({ timeSeries, chartTitle, yAxisTitle }) => {
  const data = timeSeries?.site?.time_series_container || {};
  if (!data) return null;

  const roadTempData = data.series_road_temperature || [];
  const airTempData = data.series_temperature || [];
  const dewPointData = data.series_dew_point || [];

  const epochStart = parseInt(data.epoch_start_time, 10);
  const firstDelta = parseInt(data.first_time_delta_seconds, 10);
  const interval = parseInt(data.remaining_time_delta_seconds, 10);

  const seriesData = roadTempData.map((_, index) => ({
    x: calculateTime(index, epochStart, firstDelta, interval),
    roadTemp: roadTempData[index],
    airTemp: airTempData[index],
    dewPoint: dewPointData[index],
  }));

  const options = {
    chart: {
      type: 'line',
      height: 250,
      zoomType: 'x',
      panning: true,
      panKey: 'shift',
    },
    title: {
      align: 'left',
      text: chartTitle,
    },
    subtitle: {
      align: 'left',
      text: 'Click chart and drag to zoom',
    },
    xAxis: {
      type: 'datetime',
      labels: {
        formatter: function () {
          return formatTime(this.value / 1000);
        },
      },
      tickInterval: 12 * 3600 * 1000,
    },
    yAxis: {
      visible: true,
      title: {
        text: yAxisTitle,
      },
      labels: {
        enabled: true,
      },
      gridLineWidth: 0,
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false,
        },
        enableMouseTracking: true,
      },
      series: {
        states: {
          inactive: {
            opacity: 1,
          },
        },
      },
    },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        let tooltipHtml = `<div>Time: ${formatTime(this.x / 1000)}<br/><ul>`;

        this.points.forEach((point) => {
          tooltipHtml += `<li><span style="color:${point.series.color}">${point.series.name}: </span><strong>${point.y} °C</strong></li>`;
        });

        tooltipHtml += '</ul></div>';
        return tooltipHtml;
      },
      positioner: function (labelWidth, labelHeight, point) {
        const chartWidth = this.chart.chartWidth;
        const chartHeight = this.chart.chartHeight;
        const tooltipX = point.plotX + this.chart.plotLeft - labelWidth / 2;
        const tooltipY = point.plotY + this.chart.plotTop - labelHeight - 10;

        return {
          x: Math.max(0, Math.min(tooltipX, chartWidth - labelWidth)),
          y: Math.max(0, Math.min(tooltipY, chartHeight - labelHeight)),
        };
      },
      zIndex: 1000,
    },
    series: [
      {
        name: 'Road Temperature',
        data: seriesData.map((point) => [point.x, point.roadTemp]),
        color: '#0000FF',
      },
      {
        name: 'Air Temperature',
        data: seriesData.map((point) => [point.x, point.airTemp]),
        color: '#FF0000',
      },
      {
        name: 'Dew Point',
        data: seriesData.map((point) => [point.x, point.dewPoint]),
        color: '#00FF00',
      },
    ],
    legend: {
      enabled: true,
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      floating: false,
      backgroundColor: '#FFFFFF',
      itemStyle: {
        color: '#333333',
      },
      itemHoverStyle: {
        color: '#000000',
      },
    },
    credits: {
      enabled: false,
    },
  };

  return (
    <div className="mb-10">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default RoadChart;
